import { SignupRequest } from "../pages/Admin/UserRequests/signupRequestsMockData";
import { fetchDataV2, patchDataV2, postDataV2 } from "./utils";

// Live now - confirmed directly against cedar-backend (feat-2/cedar-restructure,
// routes/admin.py + services/user.py). Same migration shape as dashboardAccessRequestsApi.ts's
// admin queue: moved from /user_service/signup-requests to /admin/signup-requests, and the status
// query param is `status_filter` (required - SignUpFilterSchema has no default), not `status`.
export const getSignupRequests = (status: SignupRequest["status"] = "pending"): Promise<SignupRequest[]> =>
  fetchDataV2(`/admin/signup-requests?status_filter=${status}`).then((response) => (Array.isArray(response) ? response : []));

export interface SignupRequestDecisionResponse {
  status: "success" | "failure";
  status_code: string;
}

// The reject route's request payload is DashboardAccessRequestNoteSchema - the same {note?: string}
// shape (default "No notes provided") dashboardAccessRequestsApi.ts's approve/reject already sends,
// not a response field despite how it first read.
export const rejectSignupRequest = (id: number, decisionNote?: string): Promise<SignupRequestDecisionResponse> =>
  postDataV2(`/admin/signup-requests/${id}/reject`, { note: decisionNote });

// PATCH /admin/signup-requests/{id} with {status: "approved", domain}. The backend
// (UserService.approve_signup_request) creates the user itself from the signup request's own
// stored fields and auto-assigns the "BASIC" view group - `domain` is only used to build the
// welcome-email link, same as `?domain=` on POST /user_service/create. There's no
// created_user_id field anymore; the admin adjusts groups/views afterward via the normal Users
// table, same as AdminRequests.tsx's own resolved approve flow.
export const approveSignupRequest = (id: number, domain: string): Promise<SignupRequestDecisionResponse> =>
  patchDataV2(`/admin/signup-requests/${id}`, { status: "approved", domain });
